import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  grid: {
    "& .MuiTableContainer-root": {
      overflowY: "hidden",
    },
  },
  ssccQuantity: {
    font: "normal 700 20px Manrope",
  },
  leftMargin: {
    marginLeft: "8px",
  },
  button: {
    cursor: "pointer",
  },
  totalQuantity: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    gap: "8px",
    padding: "6px 12px",
    font: "normal 600 18px/24px Manrope",
    color: "#465869",
  },
  totalQuantityLabel: {
    font: "normal 700 20px/24px Manrope",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "15px",
  },
  actionButtons: {
    marginTop: 12,
    width: "100%",
  },
  buttonOff: {
    cursor: "auto",
    "& svg": {
      color: "rgba(	71, 84, 103, 0.5) !important",
    },
  },
  badge: {
    justifyContent: "flex-start",
  },
  saveAndBook: {
    color: "#32D583",
    border: "1px solid #32D583",
    backgroundColor: "transparent",
    "&:hover": {
      color: "#6CE9A6",
      borderColor: "#6CE9A6",
      backgroundColor: "transparent",
    },
    "&:active": {
      border: "none",
    },
    "&:disabled": {
      border: "none",
    },
  },
  addMark: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    whiteSpace: "nowrap",
  },
  tooltipTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "4px",
    whiteSpace: "nowrap",
  },
  tooltipContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  editActionsContainer: {
    display: "flex",
    flexDirection: "row",
    transform: "translate(-6px)",
  },
  lineColumn: { paddingLeft: "10px !important", width: "30%" },
  tableCell: {
    minHeight: "65px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  emptyDataContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  emptyDataText: {
    fontFamily: "Manrope",
    fontSize: "24px",
    color: "#475467",
  },
  markAndNumbersField: {
    width: "180px",
    height: "32px",
  },
  descriptionField: {
    width: "272px",
    height: "32px",
  },
}));

export default styles;
